export default __webpack_public_path__ + "static/media/kitchen-pack-9.37d38f74.png";